namespace GeniuzPOS.LogManage {
    export namespace LogUserPasswordChangeDateService {
        export const baseUrl = 'LogManage/LogUserPasswordChangeDate';

        export declare function Create(request: Serenity.SaveRequest<LogUserPasswordChangeDateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LogUserPasswordChangeDateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LogUserPasswordChangeDateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LogUserPasswordChangeDateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "LogManage/LogUserPasswordChangeDate/Create",
            Update = "LogManage/LogUserPasswordChangeDate/Update",
            Delete = "LogManage/LogUserPasswordChangeDate/Delete",
            Retrieve = "LogManage/LogUserPasswordChangeDate/Retrieve",
            List = "LogManage/LogUserPasswordChangeDate/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LogUserPasswordChangeDateService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
